var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".date_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21,
    x: 0.5,
    y: 2.501,
    className: "date_svg__a",
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5.501v5M18.5.501v5M.5 7.501h23M6.5 19.001h5M9 19v-7.5a.5.5 0 0 0-.812-.391L6.5 12.46M15.5 19l2.931-7.255a.47.47 0 0 0-.005-.5.55.55 0 0 0-.464-.245H14a.5.5 0 0 0-.5.5v1",
    className: "date_svg__a"
  })));
};
export default SvgDate;